import Header from '@/components/base/Header';
import Footer from '@/components/base/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51动漫网',
    url: 'https://www.51dmw.com/',
    description: '51动漫网官方品牌主页，汇集日漫、国漫、韩漫等好看漫画的免费在线阅读平台',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.51dmw.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '51动漫网 | 免费好看的动漫在线阅读大全',
    description: '51动漫网官方品牌主页，汇集51动漫网站与51动漫官网入口，为您提供日漫、国漫、韩漫等好看漫画的免费在线阅读与下拉式追更体验。',
    url: 'https://www.51dmw.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '51动漫网',
      url: 'https://www.51dmw.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>
      <ScrollToTop />
      <Header />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotRecommend />
        <LatestUpdate />
        <RankingSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}